import { Button, Page, Stack } from "@towersystems/roam-common-native";

import ColorPicker, {
  Panel1,
  Swatches,
  Preview,
  HueSlider,
} from "reanimated-color-picker";
import { GenerateAiIconFormValues } from "../../../../components/GenerateAiIconForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import React from "react";
import { GenerateAiIconRootParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";

export type PickIconThemeScreenProps = NativeStackScreenProps<
  GenerateAiIconRootParamList,
  "PickIconThemeScreen"
>;

export const PickIconThemeScreen = ({
  navigation,
}: PickIconThemeScreenProps) => {
  const { watch, setValue } = useFormContext<GenerateAiIconFormValues>();
  const watchedColorTheme = watch("colorScheme");
  const [onChangeValue, setOnChangeValue] = React.useState(
    watchedColorTheme || "#FFFFFF"
  );
  const footerMarkup = (
    <View row>
      <View flex>
        <Button
          label={"Use this color"}
          isAction
          onPress={() => {
            setValue("colorScheme", onChangeValue);
            navigation.pop();
          }}
        ></Button>
      </View>
    </View>
  );

  return (
    <Page
      title="Select Color"
      secondaryTitle="Select a color theme for your icon"
      footer={footerMarkup}
    >
      <ColorPicker
        style={{ width: "70%" }}
        value={watchedColorTheme ?? "#FFF"}
        onComplete={() => null}
        onChange={(color) => {
          setOnChangeValue(color.hex);
        }}
      >
        <Stack vertical spacing={10}>
          <Preview />
          <Panel1 />
          <HueSlider />
          <Swatches />
        </Stack>
      </ColorPicker>
    </Page>
  );
};
